<div aria-modal="true" role="dialog" class="modal__wrapper eds-dialog-overrides" (click)="onOverlayClicked()">
	<div class="modal__backdrop"></div>
	<div aria-labelledby="modalHeading" aria-describedby="modalContent" class="modal" role="dialog"
	     style="touch-action: none; -webkit-user-drag: none; -webkit-tap-highlight-color: transparent; user-select: none;"
	     tabindex="-1" (click)="onModalClicked($event)" [ngClass]="config.modalClass" #modalContainer
	     (resized)="resized()">

		<div *ngIf="config.headerContent" class="modal__header u-pt-" #modalHeader>
			<p class="modal__heading" id="modalHeading">{{config.headerContent}}</p>

			<button *ngIf="!config.disableHeaderCloseBtn" id="close-icon" (click)="closeModal($event)"
			        aria-label="Close" class="button button--icon button--close">
				<svg-icon name="ico-close-16"
				          [svgStyle]="{ 'width.px': 16, 'height.px': 16, 'fill': 'currentColor' }"></svg-icon>
			</button>
		</div>


		<ng-container *ngIf="config.contentType === 'string' || config.contentType === 'template'">
			<div class="modal__content">
				<ng-container *ngIf="config.contentType === 'string'">
					<div>
						<div [innerHTML]="config.content"></div>
					</div>
				</ng-container>

				<ng-container *ngIf="config.showUri">
					<div class="u-pb----">
						<a href="{{config.uri}}" target="_blank">
							<span [innerHTML]="config.uri"></span>
						</a>
					</div>
				</ng-container>

				<ng-container *ngIf="config.contentType === 'template'">
					<ng-container *ngTemplateOutlet="config.content"></ng-container>
				</ng-container>
			</div>

			<div class="modal__footer u-pv" *ngIf="!config.disableNoBtn || config.isDecisionModal">
				<label *ngIf="config.showChkBox" for="modal-checkbox" class="checkbox">
					<input id="modal-checkbox" type="checkbox" class="checkbox__input" [(ngModel)]="config.chkBoxValue"
					       [ngClass]="{'checkbox-selected': config.chkBoxValue}">
					<span id="checkBox_label" class="checkbox__label">{{ config.chkBoxTxt }}</span>
				</label>
				<button type="button" id="decision-notification-yes-btn" tabindex="1"
				        class="button button--primary button--accept text-ellipsis display-inline-block"
				        *ngIf="config.isDecisionModal" [tooltip]="config.yesButtonLabel"
				        (click)="closeModal($event, 'YES')"
				        [ngClass]="{
                  'disabled display-inline-block': !config.enableYesBtn ,
                  'btn decision-modal-btn': !config.isScanDoc ,
                  'btn decision-modal-btn decision-modal-btn-scanDoc ':config.isScanDoc}"
				        [disabled]="!config.enableYesBtn"
				        [innerHTML]="config.yesButtonLabel">
				</button>
				<button type="button" tabindex="2" id="decision-notification-no-btn"
				        class="button button--tertiary button--reject text-ellipsis display-inline-block"
				        *ngIf="!config.disableNoBtn" [tooltip]="config.noButtonLabel"
				        (click)="closeModal($event, 'NO')"
				        [innerHTML]="config.noButtonLabel">
				</button>
			</div>
		</ng-container>

		<!-- For Component, you should include modal and footer classes in the component HTML -->
		<ng-container *ngIf="config.contentType === 'component'">
			<ng-template appModalChildComponent></ng-template>
		</ng-container>
	</div>
</div>
